import React from 'react';
import intl from 'react-intl-universal';

import CustomForm, { IFieldItem, IMyFormRef } from '@/components/CustomForm';
import { OperationTagOption, OperationResultOption } from '@/pages/order/operationLog/helper';

import styles from './index.module.scss';

// 筛选
interface FormProps {
  formRef: React.Ref<IMyFormRef>;
  onFilter: () => void;
}

const FormAttr: Array<IFieldItem> = [
  {
    label: intl.get('roomstate_take_care_record_column_crate_time'),
    key: 'operationDate',
    type: 'dateTimeRange',
    componentProps: {
      allowClear: false,
    },
  },
  {
    label: intl.get('order_operation_log_tag'),
    key: 'tag',
    type: 'select',
    dataSource: OperationTagOption,
    componentProps: {
      style: {
        width: 120,
      },
    },
  },
  {
    label: intl.get('order_operation_log_result'),
    key: 'operationResult',
    type: 'select',
    dataSource: OperationResultOption,
    componentProps: {
      style: {
        width: 120,
      },
    },
  },
];

const Index: React.FC<FormProps> = (props) => {
  const { formRef, onFilter } = props;

  return (
    <CustomForm
      layout="inline"
      submitType="filter"
      className={styles.searchForm}
      ref={formRef}
      formAttr={FormAttr}
      onValuesChange={onFilter}
    />
  );
};

export default Index;
